import { render, staticRenderFns } from "./AddAccountTypesComponent.vue?vue&type=template&id=4ede4e7a&"
import script from "./AddAccountTypesComponent.vue?vue&type=script&lang=js&"
export * from "./AddAccountTypesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports